import {
  CorporationHasDirectorAdditionalInformation,
  DirectorPersonalDetails,
} from '@commenda/types/src/random';
import { fetcher } from '@commenda/utils';

export interface UpdateMultipleDirectorInputType {
  id: number;
  // The workRequestId that you want to connect this director to
  wrkReqId?: string;
  // The workRequestId that you want to disconnect this director from
  workRequestIdToDisconnect?: string;

  corporationHasDirector?: {
    corporationId: number;
    directorId: number;
    additionalDirectorInformation?: CorporationHasDirectorAdditionalInformation;
  }[];

  ssn?: string;
  email?: string;
  number?: string;

  personalDetails?: DirectorPersonalDetails;

  corporationIdsToDisconnect?: number[];
}

// Sometimes we need to update multiple directors in a single transaction
// This hook can be used for it. The actual backend supports all director data update, so when needed update UpdateMultipleDirectorInputType
export async function updateMultipleDirectors(
  directors: UpdateMultipleDirectorInputType[],
  token: string
): Promise<boolean> {
  try {
    const res = await fetcher(
      'director/updateDirectors',
      { method: 'POST', body: { directors } },
      token
    );

    if (!res.ok) return false;

    return true;
  } catch (err) {
    console.error(err);
    return false;
  }
}
